<template>
  <div id="app">
    <p>Тест в соответствии с Figma URL:</p>
    <a
      href="https://www.figma.com/proto/KNidW3r7yNO9upvKgXUMsJWq/Test?node-id=2%3A195&scaling=min-zoom"
      target="_blank"
    >
      Figma Test
    </a>

    <div class="form">
      <template v-for="(item, index) in items">
        <div
          :key="'grp' + index"
          class="form__group"
        >
          <label
            :key="'lbl'+index"
            for="a"
            class="form__label"
          >
            Контролл {{ index + 1 }}
          </label>
          <input-control
            :key="index"
            :item="item"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import InputControl from './components/InputControl.vue'
import { mapGetters, mapActions } from 'vuex'
import { items } from './config.js'

export default {
  name: 'App',
  components: {
    InputControl
  },
  data: () => ({
    items
  }),
  computed: {
    ...mapGetters([
      'getControls',
      'getTabIndex',
      'getTabIndexTotal'
    ])
  },
  mounted() {
    document.body.addEventListener('click', this.outsideThisControl)
    document.addEventListener('keydown', this.handler)

    const inputControls = document.getElementsByClassName('form__input')
    this.$store.commit('SET_TAB_INDEX_TOTAL', inputControls.length)
  },
  destroyed() {
    document.body.removeEventListener('click', this.outsideThisControl)
    document.removeEventListener('keydown', this.handler)
  },
  methods: {
    ...mapActions([
      'outsideThisControl'
    ]),
    handler(event) {
      if (
        (event.key === 'Tab' && event.shiftKey) ||
        (event.which === 9 && event.shiftKey) ||
        (event.code === 'Tab' && event.shiftKey) ||
        (event.code === 'Tab' && event.shiftKey)
      ) {
        event.preventDefault()
        let currentIndex = this.getTabIndex

        --currentIndex
        currentIndex = (currentIndex < 0) ? 2 : currentIndex

        this.$store.commit('SET_ENABLE_EDIT', { control: currentIndex, value: true })
        this.$nextTick(() => {
          document.getElementById('input' + currentIndex).focus()
          this.$store.commit('SET_TAB_INDEX_CURRENT', currentIndex)
        })
      } else if (event.key === 'Tab' || event.which === 9 || event.code === 'Tab') {
        event.preventDefault()

        let currentIndex = this.getTabIndex
        const total = this.getTabIndexTotal

        ++currentIndex

        if (currentIndex >= total) {
          currentIndex = 0
        }

        this.$store.commit('SET_ENABLE_EDIT', { control: currentIndex, value: true })
        this.$nextTick(() => {
          document.getElementById('input' + currentIndex).focus()
          this.$store.commit('SET_TAB_INDEX_CURRENT', currentIndex)
        })
      } else if (event.key === 'Escape' || event.which === 27 || event.code === 'Escape') {
        event.preventDefault()
        this.$store.dispatch('disableAllControls')
      }
    }
  }
}
</script>
